import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetAllConnectPromotions(club) {
  var url = "/reservation/get_all_enabled_promotions_connections/" + club;

  return FetchGetDataWithAuthNEW(url);
}
